import { Button } from 'antd';
import React from 'react'
import { useNavigate } from 'react-router-dom';

export default function EventTrackerHome() {
    const navigate = useNavigate()
    return (
        <div>
            <h2>SEIMS Events App</h2>
            <p>Content coming soon for SEIMS App.....</p>
            <Button type="primary" onClick={() => navigate('/')}>Back Home</Button>
        </div>
    )
}
